export default __webpack_public_path__ + "static/media/tick-green.e9a546ee.svg";